const BIN_COUNT = 9;
const BIN_MIN = 50;
const BIN_WIDTH = 5;

export function bucketScores(scores: number[]): number[] {
  const buckets = new Array(BIN_COUNT).fill(0);
  for (const s of scores) {
    if (s < BIN_MIN || s > 100) continue;
    const idx = Math.min(BIN_COUNT - 1, Math.floor((s - BIN_MIN) / BIN_WIDTH));
    buckets[idx]++;
  }
  return buckets;
}

interface Props {
  scores: number[];
  maxHeight?: number;
}

export function ScoreHistogram({ scores, maxHeight = 18 }: Props) {
  const buckets = bucketScores(scores);
  const max = Math.max(1, ...buckets);
  return (
    <span
      className="inline-flex items-end gap-[1.5px]"
      style={{ height: maxHeight }}
      role="img"
      aria-label={`Score distribution across ${scores.length} papers from 50 to 100 in 5-point bins`}
    >
      {buckets.map((count, i) => (
        <span
          key={i}
          data-bar
          className="rounded-t-sm bg-indigo-400/85"
          style={{
            width: 6,
            height: Math.max(2, Math.round((count / max) * maxHeight)),
            opacity: count === 0 ? 0.25 : 1,
          }}
          title={`Scores ${BIN_MIN + i * BIN_WIDTH}–${BIN_MIN + (i + 1) * BIN_WIDTH}: ${count}`}
        />
      ))}
    </span>
  );
}
